define('Responsive/controllers/ScrollPanelViewController',['require','exports','module','./ViewController','../adapters/PanelAdapter','message-service/message-service','../delegates/SwipeableViewDelegate','../util/noop','../vendor','../util/object','../util/array'],function(require,exports,module){
        
    var ViewController = require( './ViewController' ),
        PanelAdapter = require( '../adapters/PanelAdapter' ),
        messageService = require( 'message-service/message-service' ),
        SwipeableViewDelegate = require( '../delegates/SwipeableViewDelegate' ),
        _noop = require( '../util/noop' );

    var ReVendor = require( '../vendor' ),
        ReMerge = require( '../util/object' ).merge,
        ReArray = require( '../util/array' );

    var Superclass,
        doc = document,
        config = {
            views               : [],
            canSwipe            : true,
            preload             : 1
        },
        classNameBase="ScrollPanelView",
        hasFlex=!ReVendor.isAndroid && ReVendor.check('boxFlex') || ReVendor.check('flex'),
        undef,

    /**
     * ScrollPanel helpers
     */
    displayForScroll = function(){
        if(this.switchcache[this.focus]){
            return this.switchcache[this.focus];
        }
        var wrap=this.wrap,
            count=this.viewCount,
            wing=this.config.preload,
            center=this.focus>0 ? this.focus : 0,
            left = center-wing,
            right= center+wing,
            wings=new RegExp("["+[
                (left < 0 ? (wrap ? (count+left) + "-" + (this.viewCount-1) + "|0" : 0) : left) + 
                "-"+center,
                center + "-" + (right >= count ? (wrap ? (count-1) + "|" + (right-count) + "-" : count-1) : right)
            ].join(']|[') + "]");

        return this.switchcache[this.focus]=wings;
    },

    displayViews= function(dir) {
        dir=(dir && dir < 0 ? -1 : 1);
        var i=0,
            viewTest=displayForScroll.call(this),
            len=this.viewCount,
            slots=this.slots;
        
        slots[this.prev].setActiveClass();
        slots[this.focus].setActive(true);
        for(;i<len;i++){
            slots[i].setActive(viewTest.test(i));
        }
    },
    
    reflow = function(){
        if(hasFlex){
            return;
        }
        var i=0,
            len=this.viewCount,
            holderWidth=100 * len + "%",
            slots=this.slots;
        
        if(this.viewHolder.style.width!==holderWidth){
            this.viewHolder.style.width=holderWidth;
            for(;i<len;i++){
                slots[i].setWidthPercent();
            }
        }
    },

    scrollWatchers={
        stayInBounds : true,
        watchers    : {
            canSwipe: function(){
                return this.canSwipe;
            },
            beforeChange : function(){
                this.setAnimating(true);
                //this.showOverlay();
            },
            change  : function(dir){
                var that=this,
                    newindex=that.focus+dir,
                    viewCount=that.viewCount;

                that.setViewFocus((
                    newindex < 0 ? newindex+viewCount : 
                        newindex >= viewCount ? viewCount-newindex : 
                            newindex
                        )
                    ,dir);
                that.hideOverlay();
                //this.setAnimating(false);

            }
        }
    };
    
    
    function ScrollPanelViewController(options){
    
        var that=this;
        // Call super constructor
        Superclass.constructor.call(this);
        options=options||{};
        this.viewHolder=null;
        this.focus=0;
        this.config=ReMerge(config,options);
        this.viewCount=0;
        this.start=this.config.start||0;
        this.title=this.config.title||"ScrollPanelViewController";
        this.referenceName = this.title;
        this.config.views=ReArray.ensureArray(this.config.views);
        this.views = this.config.views.map(function(_view,index){
            return ReMerge(_view);
        });
        this.slots=[];
        this.slotsById={};
        this.swipe=options.swipe===false ? false : true;
        this.swipeOpts=options.swipeOpts||{};
        this.nav=null;
        this.wrap=!!this.config.wrap;
        // this.uiDelegate=null;
        this.hibernate=true;
        this.uiDelegate=new SwipeableViewDelegate(ReMerge(scrollWatchers,this.swipeOpts));

        messageService.publish("registerViewComponent", this);
        return this;
    }
    
    ViewController.spawn( ScrollPanelViewController).define({
        PanelAdapter : PanelAdapter,

        addView : function(_view){
            var newSlot;
            this.childViewControllers.push(_view.viewController);
            _view.index=this.viewCount++;
            _view.viewController.parentViewController = this;
            newSlot=new this.PanelAdapter(this,_view);
            this.slots.push(newSlot);
            this.slotsById[newSlot.id.toLowerCase()]=newSlot;
                // If we're adding a child view to the controller
                // after we're loaded
            if(this.isViewLoaded() && !this.hibernate){
                this.switchcache={};
                this.draw();
            }
        },
        
        replaceActiveView : function(_view, position){
            position = position || 0;
            
            // Unload view that is getting replaced
            if(this.slots[position]){
                this.slots[position].destroy();
            }
            this.childViewControllers[position] = _view.viewController;
            _view.index = position;
            
            _view.viewController.parentViewController = this;
            
            this.slots[position] = new this.PanelAdapter(this, _view, position);
            
            // If we're adding a child view to the controller
            // after we're loaded
            if(this.isViewLoaded() && !this.hibernate){
                this.switchcache={};
                this.draw();
            }
        },
        
        setSwipeable : function(canSwipe){
            this.canSwipe=!!canSwipe;
            return this;
        },
        
        setSwipeTransition : function(transition){
            this.swiptOpts.transformType=transition||null;
        },
        
        draw: function() {
            Superclass.draw.call(this);
            this.hibernate=false;
                //Re-set the canSwipe actions for the uiDelegate;
            this.setSwipeable(this.canSwipe);
            reflow.call(this);
            
            if(this.start!==this.focus){
                this.uiDelegate.scrollTo(this.start,this.focus);
            }else{
                this.setViewFocus(this.start);
            }
            this.start=this.focus;
            this.viewHolder.setAttribute('data-loading','false');
        },
    
        loadView: function() {
            var nav,
                i=0,
                len=this.views.length;

            this.canSwipe= this.swipe && !!this.config.preload && !!ReVendor.transition;
            this.switchcache={};

            Superclass.loadView.call(this);
            this.view.className=classNameBase + " " + classNameBase+"Controller";
            this.viewHolder = this.viewHolder||doc.createElement("div");
            this.viewHolder.className=classNameBase+"-pages";
            this.animating=false;

            this.viewHolder.setAttribute('data-loading','true');
            this.offsetView = this.viewHolder;
            if(this.config.nav){
                this.navContainer=nav=doc.createElement('nav');
                this.view.appendChild(nav);
                this.nav=doc.createElement('ul');
                this.nav.className=classNameBase+"-nav"
                + (typeof this.config.nav==="string" ? " "+this.config.nav : "");

                nav.appendChild(this.nav);
            }
            
            for(;i<len;i++){
                this.addView(this.views[i]);
            }
            this.view.appendChild(this.viewHolder);
            if(this.focus >= this.viewCount){
                this.focus=this.viewCount-1;
            }
            this.uiDelegate.create(this.viewHolder,this);
        },

        // setAvailableHeight : function(){
        //     Superclass.setAvailableHeight.call(this);
        //     console.warn('spanel',this.availableHeight, this.navContainer && this.navContainer.offsetHeight, this.navContainer && this.navContainer.getBoundingClientRect());
        //     this.heightOffset=(this.navContainer ? this.navContainer.offsetHeight : 0);
        // },
        setAnimating : function(isAnimating){
            this.animating=!!isAnimating;
        },

        isAnimating : function(){
            return this.animating;
        },

        viewDidUnload: function(){
            var i=0,
                len=this.slots.length;

            Superclass.viewDidUnload.call(this);
            this.start=this.focus;
            this.focus=0;
            this.view=null;
            this.hibernate=true;
            this.uiDelegate.destroy();
            for(;i<len;i++){
                this.slots[i].destroy();
            }
            this.viewHolder=null;
            this.nav=null;
            this.viewCount=0;
            this.slots=[];
        },
        
        setNav  : function(type){
            this.config.nav=type;
            if(!type && this.nav){
                this.nav.style.display="none";
            }else if(this.nav){
                this.nav.style.display="block";
            }
        },
        
        setViewFocus: function(index,dir) {
            this.prev=this.focus;
            this.focus= index===undef ? this.focus : index;
            if(!this.isViewLoaded()) {
                return;
            }
            displayViews.call(this,dir);
            this.start=this.focus;
        },
        setTabView : function(tabId, evt) {
            if (tabId === undef) { 
                return; 
            }
            
            var calledSlot = this.slotsById[tabId.toLowerCase()],
                idx = (calledSlot && calledSlot.view) ? calledSlot.view.index : 0;
            this.jumpTo(idx);
        },

        jumpTo : function(index){
            this.uiDelegate.scrollTo(index,this.focus);
        }
    });
    Superclass=ScrollPanelViewController.superclass;
    return ScrollPanelViewController;
});

